import React from 'react'

import { graphql, useStaticQuery } from 'gatsby'

import WordpressMenu from '@components/Wordpress/WordpressMenu'

import { WpMenuType } from '@contracts/Wordpress'

import * as styles from './FooterMenu.module.scss'

const FooterCompanyMenu = () => {
	const data = useStaticQuery(graphql`
		query CompanyMenu {
			wpMenu(locations: { eq: COMPANY_MENU }) {
				menuItems {
					nodes {
						label
						title
						path
						parentId
						id
						children {
							id
						}
					}
				}
			}
		}
	`)

	const menuData: WpMenuType = data.wpMenu.menuItems

	return <WordpressMenu data={menuData} className={styles.menu} />
}

export default FooterCompanyMenu
